import { render, staticRenderFns } from "./TextNoteLinks.vue?vue&type=template&id=7e643a54"
import script from "./TextNoteLinks.vue?vue&type=script&lang=js"
export * from "./TextNoteLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports